import React from "react";
import { FaLayerGroup, FaUsers } from "react-icons/fa";

import {
  DEFAULT_USER_AVATAR,
  formatLimit,
  getProgressPercent,
  getUserFullName,
} from "../utils/groupsUtils";

function ProgressLine({ icon: Icon, label, value, max, percent, tone }) {
  return (
    <div>
      <div className="mb-2 flex items-center justify-between gap-3">
        <p className="inline-flex items-center gap-2 text-sm font-bold text-slate-700 dark:text-white/80">
          <Icon className={tone} />
          {label}
        </p>

        <p className="text-sm font-bold text-slate-500 dark:text-white/50">
          {value}/{formatLimit(max)}
        </p>
      </div>

      <div className="h-3 overflow-hidden rounded-full bg-slate-200 dark:bg-white/10">
        <div
          className={`h-full rounded-full transition-all ${tone.replace(
            "text-",
            "bg-",
          )}`}
          style={{ width: `${max === Infinity ? 100 : percent}%` }}
        />
      </div>
    </div>
  );
}

function CoachLimitsCard({ user, userRole, userLimits, stats }) {
  return (
    <div className="mt-5 grid gap-4 lg:grid-cols-[0.9fr_1.1fr]">
      <div className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.05]">
        <div className="flex items-center gap-4">
          <img
            src={user?.photoURL || user?.photo_url || DEFAULT_USER_AVATAR}
            alt={getUserFullName(user)}
            className="h-16 w-16 rounded-2xl object-cover ring-4 ring-white dark:ring-white/10"
            onError={(event) => {
              event.currentTarget.src = DEFAULT_USER_AVATAR;
            }}
          />

          <div className="min-w-0">
            <p className="truncate font-titre text-2xl font-bold text-slate-950 dark:text-white">
              {getUserFullName(user)}
            </p>

            <p className="mt-1 text-sm font-medium text-slate-500 dark:text-white/50">
              Rôle : {userRole || "Non défini"}
            </p>
          </div>
        </div>
      </div>

      <div className="grid gap-4 rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.05] sm:grid-cols-2">
        <ProgressLine
          icon={FaLayerGroup}
          label="Groupes"
          value={stats.groupsCount}
          max={userLimits.maxGroups}
          percent={getProgressPercent(stats.groupsCount, userLimits.maxGroups)}
          tone="text-sky-600"
        />

        <ProgressLine
          icon={FaUsers}
          label="Judokas"
          value={stats.totalAdherents}
          max={userLimits.maxAdherents}
          percent={getProgressPercent(
            stats.totalAdherents,
            userLimits.maxAdherents,
          )}
          tone="text-emerald-600"
        />
      </div>
    </div>
  );
}

export default CoachLimitsCard;